import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, offerIncludes, offerRows } from '../data/matematik';
import { PRODUCT_IMAGE } from '../data/assets';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-241" data-mp="1mpd6k6sau58i">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-242" data-mp="1hqs5y694xjjj">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-243" data-mp="u0xthpsq9wzt">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-244" data-mp="p0jx550hobhm">
            Få hele <em className="whitespace-nowrap text-red-300" style={{
            hyphens: 'manual'
          }} data-id="element-245" data-mp="13y2h7u2820iq">NATURKLAR™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-246" data-mp="ywd488vfvcs0">
            Hele skoleåret i natur/teknologi – færdigplanlagt. Klar på 5 minutter.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-247" data-mp="2adwgsruwss38" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-248" data-mp="pjz31ttgrfy9">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-249" data-mp="zhvbueyxhyt7">Hele pakken indeholder</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-250" data-mp="13jq9n9hnhu28">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-251" data-mp="6u95x028ai36">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-252" data-mp="6rwg60q8b3fk">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-253" data-mp="funvwcq50ld0" />
                </span>
                <span data-id="element-254" data-mp="kle19pykco7p">
                  <span className="block font-medium leading-snug" data-id="element-255" data-mp="klxj76o7rclq">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-256" data-mp="3k7kpwprt5gku">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-257" data-mp="vfqv3wjgh2pk">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-258" data-mp="qfurvzil1fb2">Introduktionspris <s className="ml-1 text-slate-900/50" data-id="element-259" data-mp="155tnbuir6cmu">{PRICE_BEFORE}</s></p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-260" data-mp="106h19bzph9lb">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-261" data-mp="chemqd0dbwv1">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-262" data-mp="7jmjwny6qqc2" />
            Engangsbetaling. Intet abonnement.
          </p>

          <CtaButton label="Få hele pakken nu" className="mt-8 w-full" data-id="element-263" data-mp="hfzd7kptj26a" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-264" data-mp="heoazpc0u2ha">
            {offerIncludes.map(item => <li key={item} data-id="element-265" data-mp="1svej5e0094dj">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}